const downloadCards = [
  {
    icon: 'ri-android-fill',
    title: '安卓版',
    sub: 'Android',
    desc: '适用于主流安卓设备，支持离线缓存、更新推送与横屏翻页。',
    cta: '立即下载',
    primary: true,
  },
  {
    icon: 'ri-apple-fill',
    title: 'iOS 版',
    sub: 'iPhone / iPad',
    desc: '适用于 iPhone 与 iPad，阅读进度云端同步，跨设备无缝衔接。',
    cta: '前往下载',
    primary: false,
  },
  {
    icon: 'ri-global-line',
    title: '手机版',
    sub: '网页端',
    desc: '免下载点开即读，专为移动浏览器优化，收藏追更同样方便。',
    cta: '立即阅读',
    primary: false,
  },
];

export default function Download() {
  return (
    <section id="download" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center gap-10 px-4 md:px-6 lg:flex-row lg:justify-between">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
            <i className="ri-download-2-line" />
            移动端入口
          </span>
          <h2 className="mt-3 font-heading text-3xl leading-tight text-background-50 md:text-4xl">
            咪咕漫画网 APP 下载
          </h2>
          <p className="mt-4 text-base leading-relaxed text-background-200">
            安卓版与 iOS 版均已上线，覆盖主流移动设备。通勤路上，随时随地流畅翻页，收藏追更两不误。下载客户端后解锁离线缓存、更新推送与横屏翻页等完整体验。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <span className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-shield-check-line text-accent-400" />
              安全下载
            </span>
            <span className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-flashlight-fill text-accent-400" />
              秒速安装
            </span>
            <span className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-restart-line text-accent-400" />
              自动更新
            </span>
          </div>
        </div>

        <div className="grid w-full max-w-xl grid-cols-1 gap-4 sm:grid-cols-3">
          {downloadCards.map((card) => (
            <article
              key={card.title}
              className={`flex flex-col rounded-lg border p-5 ${
                card.primary
                  ? 'border-primary-500/50 bg-primary-500 text-background-50'
                  : 'border-background-800 bg-background-900 text-background-50'
              }`}
            >
              <i className={`${card.icon} text-3xl ${card.primary ? 'text-background-50' : 'text-accent-400'}`} />
              <h3 className="mt-3 font-heading text-xl">{card.title}</h3>
              <p className={`mt-0.5 text-xs ${card.primary ? 'text-background-100' : 'text-background-400'}`}>{card.sub}</p>
              <p className={`mt-3 flex-1 text-xs leading-relaxed ${card.primary ? 'text-background-100' : 'text-background-300'}`}>
                {card.desc}
              </p>
              <a
                href="#download"
                className={`mt-4 inline-flex items-center justify-center gap-1 whitespace-nowrap rounded-md px-4 py-2.5 text-xs font-bold transition-colors ${
                  card.primary
                    ? 'bg-background-50 text-primary-700 hover:bg-background-100'
                    : 'bg-accent-500 text-foreground-950 hover:bg-accent-400'
                }`}
              >
                {card.cta}
                <i className="ri-arrow-right-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}